import { ActionReducerMap } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { alertsReducers } from "./alert.reducers";
import { loadingReducers } from "./loading.reducer";
import { userReducers } from "./user.reducer";

export const appReducers: ActionReducerMap<IAppState, any> = {
  user: userReducers,
  alert: alertsReducers,
  loading: loadingReducers,
};
